import {
  STAKE_SETTINGS_RFUEL,
  STAKE_DETAILS_RFUEL,
  STAKE_SEND_RFUEL,
  STAKE_SUCCESS_RFUEL,
  STAKE_ERROR_RFUEL,
  RESET_STAKE_RFUEL,
  STAKE_BALANCE_RFUEL,
  STAKE_TIME_RFUEL,
  UNSTAKED_BALANCE_RFUEL,
  REWARD_EARNED_RFUEL,
  REWARD_BALANCE_RFUEL,
  UNSTAKE_SETTINGS_RFUEL,
  UNSTAKE_INFORMATION_RFUEL,
  UNSTAKE_DETAILS_RFUEL,
  UNSTAKE_SEND_RFUEL,
  UNSTAKE_SUCCESS_RFUEL,
  WITHDRAW_DETAILS_RFUEL,
  WITHDRAW_SEND_RFUEL,
  WITHDRAW_SUCCESS_RFUEL,
  UNSTAKE_TIME_RFUEL,
  HISTORY_SHOW_RFUEL_STAKING,
  CLAIM_REWARDS_SEND_RFUEL,
  CLAIM_REWARDS_SUCCESS_RFUEL,
} from './action-types';
import rfuelStakingContractService from '../services/contracts/rfuel-staking-contract-service';
import { getRfuelBalance, approve } from './token-actions';
import { RFUEL } from '../constants/blockchain-constants';
import config from '../config/env';
import { getTotalStakedBalance } from './staking-actions';

export const updateBalances = () => async (dispatch, getState) => {
  const { address } = getState().account;

  const [stakeBalance, rewardEarned, rewardBalance, unstakedTime] = await Promise.all([
    rfuelStakingContractService.balanceOf(address),
    rfuelStakingContractService.earned(address),
    rfuelStakingContractService.rewardBalanceOf(address),
    rfuelStakingContractService.unstakingTimeOf(address),
    dispatch(getRfuelBalance()),
  ]);

  // TODO: make one dispatch
  dispatch({ type: STAKE_BALANCE_RFUEL, payload: { stakeBalance } });
  dispatch({ type: REWARD_EARNED_RFUEL, payload: { rewardEarned } });
  dispatch({ type: REWARD_BALANCE_RFUEL, payload: { rewardBalance } });
  dispatch({ type: UNSTAKE_TIME_RFUEL, payload: { unstakedTime } });
};

// STAKE

export const stakeSettings = () => async (dispatch) => {
  dispatch({ type: STAKE_SETTINGS_RFUEL });
};

export const stakeDetails = (formValues) => async (dispatch) => {
  dispatch({ type: STAKE_DETAILS_RFUEL, payload: formValues });
};

export const stakeSend = (formValues) => async (dispatch, getState) => {
  const { address } = getState().account;
  const { amount } = formValues;
  try {
    dispatch({ type: STAKE_SEND_RFUEL });
    await approve(RFUEL, address, config.REACT_APP_RFUEL_STAKING_ADDRESS);

    const transaction = await rfuelStakingContractService.stake(address, amount);
    await dispatch(updateBalances());

    // COMPLETE
    dispatch({ type: STAKE_SUCCESS_RFUEL, payload: { id: transaction.transactionHash } });
  } catch (error) {
    dispatch({ type: STAKE_ERROR_RFUEL, payload: { error: 'Stake failed' } });
  }
};

// UNSTAKE

export const unstakeSettings = () => async (dispatch) => {
  dispatch({ type: UNSTAKE_SETTINGS_RFUEL });
};

export const unstakeInformation = (formValues) => async (dispatch) => {
  dispatch({ type: UNSTAKE_INFORMATION_RFUEL, payload: formValues });
};

export const unstakeDetails = () => async (dispatch) => {
  dispatch({ type: UNSTAKE_DETAILS_RFUEL });
};

export const unstakeSend = (formValues) => async (dispatch, getState) => {
  const { address } = getState().account;

  dispatch({ type: UNSTAKE_SEND_RFUEL });

  const { amount } = formValues;

  try {
    const transaction = await rfuelStakingContractService.unstake(address, amount);
    await dispatch(updateBalances());

    // COMPLETE
    dispatch({ type: UNSTAKE_SUCCESS_RFUEL, payload: { id: transaction.transactionHash } });
  } catch (error) {
    dispatch({ type: STAKE_ERROR_RFUEL, payload: { error: 'Unstake failed' } });
  }
};

export const claimRewardsSend = (claimType) => async (dispatch, getState) => {
  const address = await getState().account.address;

  dispatch({ type: CLAIM_REWARDS_SEND_RFUEL });

  try {
    let transaction;
    if (claimType === 'unstake') {
      transaction = await rfuelStakingContractService.withdrawReward(address);
    } else if (claimType === 'stake') {
      transaction = await rfuelStakingContractService.stakeReward(address);
    }
    await dispatch(updateBalances());

    // COMPLETE
    dispatch({ type: CLAIM_REWARDS_SUCCESS_RFUEL, payload: { id: transaction.transactionHash } });
  } catch (error) {
    dispatch({ type: STAKE_ERROR_RFUEL, payload: { error: 'Claim failed' } });
  }
};

// WITHDRAW UNSTAKED

export const withdrawUnstakedDetails = () => async (dispatch) => {
  dispatch({ type: WITHDRAW_DETAILS_RFUEL });
};

export const withdrawUnstakedSend = () => async (dispatch, getState) => {
  const { address } = getState().account;

  dispatch({ type: WITHDRAW_SEND_RFUEL });

  try {
    const unstakeBalance = await rfuelStakingContractService.unstakingBalanceOf(address);
    const transaction = await rfuelStakingContractService.withdrawUnstakedBalance(
      address,
      unstakeBalance,
    );
    await dispatch(updateBalances());

    // COMPLETE
    dispatch({ type: WITHDRAW_SUCCESS_RFUEL, payload: { id: transaction.transactionHash } });
  } catch (error) {
    dispatch({ type: STAKE_ERROR_RFUEL, payload: { error: 'Unstake failed' } });
  }
};

export const stakeReset = () => async (dispatch) => {
  dispatch({ type: RESET_STAKE_RFUEL });
};

export const showHistory = () => async (dispatch) => {
  dispatch({ type: HISTORY_SHOW_RFUEL_STAKING });
};

// VIEWS

export const getStakedBalance = () => async (dispatch, getState) => {
  const { address } = getState().account;

  const stakeBalance = await rfuelStakingContractService.balanceOf(address);
  dispatch({ type: STAKE_BALANCE_RFUEL, payload: { stakeBalance } });
  dispatch(getTotalStakedBalance());
};

export const getStakedTime = () => async (dispatch, getState) => {
  const { address } = getState().account;

  const stakeTime = await rfuelStakingContractService.stakeTime(address);
  dispatch({ type: STAKE_TIME_RFUEL, payload: { stakeTime } });
};

export const getUnstakedBalance = () => async (dispatch, getState) => {
  const { address } = getState().account;

  const unstakedBalance = await rfuelStakingContractService.unstakingBalanceOf(address);
  dispatch({ type: UNSTAKED_BALANCE_RFUEL, payload: { unstakedBalance } });
};

export const getUntakedTime = () => async (dispatch, getState) => {
  const { address } = getState().account;

  const unstakedTime = await rfuelStakingContractService.unstakingTimeOf(address);
  dispatch({ type: UNSTAKE_TIME_RFUEL, payload: { unstakedTime } });
};

export const getRewardsEarned = () => async (dispatch, getState) => {
  const { address } = getState().account;

  const rewardEarned = await rfuelStakingContractService.earned(address);
  dispatch({ type: REWARD_EARNED_RFUEL, payload: { rewardEarned } });
};

export const getRewardsBalance = () => async (dispatch, getState) => {
  const { address } = getState().account;

  const rewardBalance = await rfuelStakingContractService.rewardBalanceOf(address);
  dispatch({ type: REWARD_BALANCE_RFUEL, payload: { rewardBalance } });
};

export const initData = () => async (dispatch) =>
  Promise.all([
    dispatch(getUntakedTime()),
    dispatch(getStakedBalance()),
    dispatch(getStakedTime()),
    dispatch(getUnstakedBalance()),
    dispatch(getRewardsEarned()),
    dispatch(getRewardsBalance()),
  ]);
